import React from 'react';

const JobsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M0.000183105 9.07861C0.0501831 11.4166 0.190183 15.4156 0.210183 15.8566C0.281183 16.7996 0.642183 17.7526 1.20418 18.4246C1.98618 19.3676 2.94918 19.7886 4.29218 19.7886C6.14818 19.7986 8.19418 19.7986 10.1812 19.7986C12.1762 19.7986 14.1122 19.7986 15.7472 19.7886C17.0712 19.7886 18.0642 19.3566 18.8362 18.4246C19.3982 17.7526 19.7592 16.7896 19.8102 15.8566C19.8302 15.4856 19.9302 11.1446 19.9902 9.07861H0.000183105Z"
        fill="currentColor"
      />
      <path
        d="M9.24536 13.3843V14.6783C9.24536 15.0923 9.58136 15.4283 9.99536 15.4283C10.4094 15.4283 10.7454 15.0923 10.7454 14.6783V13.3843C10.7454 12.9703 10.4094 12.6343 9.99536 12.6343C9.58136 12.6343 9.24536 12.9703 9.24536 13.3843Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21131 12.5565C8.11131 12.9195 7.7623 13.1515 7.38431 13.1015C4.8333 12.7455 2.39531 11.8405 0.337305 10.4815C0.126305 10.3435 0.000305176 10.1075 0.000305176 9.85549V6.38949C0.000305176 4.28949 1.71231 2.58149 3.81731 2.58149H5.78431C5.97231 1.12949 7.20231 0.000488281 8.70431 0.000488281H11.2863C12.7873 0.000488281 14.0183 1.12949 14.2063 2.58149H16.1833C18.2823 2.58149 19.9903 4.28949 19.9903 6.38949V9.85549C19.9903 10.1075 19.8633 10.3425 19.6543 10.4815C17.5923 11.8465 15.1443 12.7555 12.5763 13.1105C12.5413 13.1155 12.5073 13.1175 12.4733 13.1175C12.1343 13.1175 11.8313 12.8885 11.7463 12.5525C11.5443 11.7565 10.8213 11.1995 9.9903 11.1995C9.1483 11.1995 8.43331 11.7445 8.21131 12.5565ZM11.2863 1.50049H8.70431C8.03131 1.50049 7.46931 1.96049 7.30131 2.58149H12.6883C12.5203 1.96049 11.9583 1.50049 11.2863 1.50049Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default JobsIcon;
